$(function() 
{
  let $show_less = $('#show_less_worth_discovering');
  let $show_less_features = $('#show_less_features');

  $show_less_features.addClass('d-none');
  $show_less.addClass('d-none');

  $('#show_all_features').on('click', e => 
  {
    $('#features').removeClass('d-none').slideDown(100);
    $('#show_all_features').fadeOut(300);
    $show_less_features.removeClass('d-none').fadeIn(100);
  });

  $('#show_all_worth_discovering').on('click', e => 
  {
    $('#worth-discovering').removeClass('d-none').slideDown(100);
    $('#show_all_worth_discovering').fadeOut(300);
    $('#show_less_worth_discovering').removeClass('d-none').fadeIn(300);
  });

   $show_less.on('click', e => 
  {
    $('#worth-discovering').addClass('d-none').slideUp(100);
    $('#show_all_worth_discovering').fadeIn(300);
    $('#show_less_worth_discovering').addClass('d-none').fadeOut(300);
  });

  $show_less_features.on('click', e => 
  {
    $('#features').addClass('d-none').slideUp(100);
    $('#show_all_features').fadeIn(300);
    $show_less_features.addClass('d-none').fadeOut(100);
  });

});
